import { defineMessages, FormattedMessage } from "react-intl";
import React from "react";

const messages = defineMessages({
  checkIn: {
    id: "default.checkIn",
    defaultMessage: "CheckIn",
  },
  checkOut: {
    id: "default.checkOut",
    defaultMessage: "CheckOut",
  },
  placementDate: {
    id: "default.placementDate",
    defaultMessage: "Reservation Date",
  },
  day: {
    id: "default.day",
    defaultMessage: "day",
  },
  days: {
    id: "default.days",
    defaultMessage: "days",
  },
});

export function DaysRenderer({ field, entity }) {
  const showForDuration = field.showForDuration;

  const isTimeLimit =
    entity[`${field.fieldName}TimeLimit`] &&
    entity[`${field.fieldName}TimeLimit`].timeLimit &&
    entity[field.fieldName] &&
    showForDuration &&
    showForDuration.includes(entity[field.fieldName].duration);

  if (
    !entity[field.fieldName] ||
    (entity[field.fieldName] && entity[field.fieldName].duration === undefined)
  ) {
    return (
      <span>
        {field?.fieldName === "maxRelease" ? (
          <FormattedMessage {...messages.placementDate} />
        ) : (
          <FormattedMessage {...messages.checkOut} />
        )}
      </span>
    );
  }

  if (
    entity[field.fieldName] &&
    entity[field.fieldName].duration !== undefined &&
    Number(entity[field.fieldName].duration) === 0
  ) {
    return (
      <span>
        <FormattedMessage {...messages.checkIn} />
        {isTimeLimit && <>&nbsp;{entity[`${field.fieldName}TimeLimit`].timeLimit}&nbsp;h</>}
      </span>
    );
  }

  const duration = entity[field.fieldName] && entity[field.fieldName].duration;

  return (
    <span>
      {duration}{" "}
      {duration === "1" ? (
        <FormattedMessage {...messages.day} />
      ) : (
        <FormattedMessage {...messages.days} />
      )}
      {isTimeLimit && <>&nbsp;{entity[`${field.fieldName}TimeLimit`].timeLimit}&nbsp;h</>}
    </span>
  );
}
